import styled from 'styled-components';

export const MFRPProductItemContainer = styled('div')`
    margin-left: 45px;
    margin-bottom: 40px;
`;
